import { createContext, useContext } from 'react';

const SidebarContext = createContext(false);

export const SidebarProvider = ({ sidebarOpen, children }) => (
  <SidebarContext.Provider value={sidebarOpen}>
    {children}
  </SidebarContext.Provider>
);

export const useSidebarOpen = () => useContext(SidebarContext);
